import { WithdrawMethod } from '@/feature/withdraw/hooks/use-withdrawal-methods';
import { create } from 'zustand';

type SelectedWithdrawalMethodStore = {
    selectedWithdrawalMethod: WithdrawMethod | null;
    isFantasyRedemptionSelected: boolean;
    setSelectedMethod: (method: WithdrawMethod) => void;
    setFantasyRedemptionSelected: (isSelected: boolean) => void;
    clearSelection: () => void;
};

/**
 * Custom hook to manage the selected withdrawal method state.
 * Intentionally not persisted — the selection must reset whenever the user re-enters the withdrawal flow.
 */
export const useSelectedWithdrawalMethodStore = create<SelectedWithdrawalMethodStore>()(set => ({
    selectedWithdrawalMethod: null,
    isFantasyRedemptionSelected: false,
    setSelectedMethod: method =>
        set({
            selectedWithdrawalMethod: method,
            isFantasyRedemptionSelected: false,
        }),
    setFantasyRedemptionSelected: isSelected =>
        set({
            isFantasyRedemptionSelected: isSelected,
            selectedWithdrawalMethod: isSelected ? null : undefined,
        }),
    clearSelection: () =>
        set({
            selectedWithdrawalMethod: null,
            isFantasyRedemptionSelected: false,
        }),
}));
